import { Injectable } from '@angular/core';
import { ExpenseModel } from './model/expense.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private http: HttpClient) { }

  getExpenseList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/expense/get', requestData);

  }

  getExpenseType(requestData:any): Observable<any> {
    return this.http.post(environment.baseUrl+'/expense-type/get', requestData);

  }

  getExpenseById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/expense/get/'+id, '');

  }

   /**
   * 
   * @param expenseInfo 
   * Calls the update API to insert/update the record
   */
   update(expenseInfo: ExpenseModel): Observable<any> { 
    if(expenseInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/expense/update', expenseInfo);
    } else{
      return this.http.post(environment.baseUrl+'/expense/add', expenseInfo);
    }
  }


    /**
   * 
   * @param expenseInfo 
   * Calls the API to delete the record
   */
    delete(expenseInfo: ExpenseModel): Observable<any>  {
      // alert();
      return this.http.post(environment.baseUrl+'/expense/delete/'+expenseInfo.id, expenseInfo);
    }

    // downloadExcel(requestData: any): Observable<Blob> {
    //   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //  // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
  
    //   return this.http.post(environment.baseUrl + '/department/export-department-list', requestData, { headers, responseType: 'blob' })
    //     .pipe(
    //       //catchError(this.handleError)
    //     );
  
    // }

}
